import React from "react";
import About from "./About";
import Hero from "./Hero";
import Features from "./Features";
import CustomerTestimonials from "./CustomerTestimonials";
import CallToAction from "./CallToAction";


function HomeBody() {
    return (
        <>
            <Hero/>
            <About/>
            <Features/>
            <CustomerTestimonials/>
            <CallToAction/>
        </>
    )
}
export default HomeBody;